export default __webpack_public_path__ + "static/media/email_icon.a2e0e941.png";